import { planTypes } from "@/common/constants"
import { pageConfig } from "@/common/service/page-config"
import { get } from "lodash"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      showPlanDetail: true,
    }
  },
  computed: {
    ...mapGetters(['assignInfo', 'basicConfig']),
    assignedLicense() {
      return get(this.assignInfo, [pageConfig.oldPlanCode, 'assignLicenseQuantity'], 0);
    },
    licenseTips() {
      if(this.basicConfig?.isBulkLicenseAccount) return '';
      if(this.form.selectedNumber < this.assignedLicense) {
        return this.$t('billing.planform.zoom_meeting.less_than_assigned_number_tips_no_br', [
          this.assignedLicense,
          this.assignedLicense - this.form.selectedNumber,
        ]);
      }
      return '';
    }
  },
  methods: {
    getBillingCycleDisabledDesc(billingCycle /* Options' billing cycle */) {
      const shoppingCartSelectedPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_SCHEDULER);
      const isBulkLicenseAccountDisabled = this.basicConfig.isBulkLicenseAccount;
      // only for edit flow
      if (shoppingCartSelectedPlan.billing_cycle !== billingCycle && isBulkLicenseAccountDisabled) {
        return this.$t('billing.error.buld_acount_license');
      }
    }
  }
}
